type DirectiveResult = {
	destroy: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function snippet(name: any, arg: any): any {
	if (typeof name === "function") {
		if (typeof arg === "object") {
			return name(arg);
		} else {
			return name();
		}
	}
	return name;
}

export function directive(
	result: DirectiveResult | undefined
): () => void | undefined {
	if (
		result &&
		typeof result === "object" &&
		typeof result.destroy === "function"
	) {
		return result.destroy;
	}
}

export function styleObject(text: string): Record<string, string> {
	const out: Record<string, string> = {};
	text.split(";").forEach(x => {
		const [k, v] = x.split(":");
		if (v) {
			let n = k.trim();
			if (n.indexOf("-")) n = n.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
			out[n] = v.trim();
		}
	});
	return out;
}

export function tick(): Promise<void> {
	return new Promise(resolve => {
		requestAnimationFrame(() => {
			setTimeout(resolve, 0);
		});
	});
}
